<template>
	<div class="detail">
		<div class="header">
			<van-col class="de_do" :span="12">
				<img src="../assets/yt.png" alt="">
				<span class="logo">i岳塘</span>
			</van-col>
			<van-col :span="12">
				<van-button type="danger" @click="toLinks()">打开</van-button>
			</van-col>
		</div>
		<div class="content" v-if="show">
			<iframe :src="'https://xhncloud.voc.com.cn/portal/news/show?id='+tid" frameborder="0" id="iframe" scrolling="auto"></iframe>
		</div>
	</div>
</template>

<script>
	import Vue from 'vue';
	const moment = require('moment')
	require('moment/locale/zh-cn')
	Vue.use(require('vue-moment'), {
	    moment
	})
	Vue.moment().locale();
	let Base64 = require('js-base64').Base64;
	import {Dialog} from 'vant'
	export default{
		data(){
			return{
			  appid:0,
			  show:false,
			  tid:this.$route.params.tid,
			}
		},
		methods:{
			toLinks(){
				this.osUrl();
			},
      toHome(){
			  this.$router.push('/')
      }
		},
		 mounted() {
			this.$http.get(this.baseUrl+'/v1/news/show?appid='+this.orgId+'&tid='+this.$route.params.tid).then((res)=>{
				if(res.data.statecode==1){
					document.title = res.data.data.title+'-'+document.title;
					this.show = true;
					var _paq = window._paq = window._paq || [];
					/* tracker methods like "setCustomDimension" should be called before "trackPageView" */
					_paq.push(['setCustomVariable', 1, "channel_id", "WAP", "page"]);
					_paq.push(['setCustomVariable', 2, "screen", "news_detail", "page"]);
					_paq.push(['setCustomVariable', 3, "class_id", res.data.data.ClassID, "page"]);
					_paq.push(['setCustomVariable', 4, "news_id", this.$route.params.tid, "page"]);
					_paq.push(['setCustomVariable', 5, "editor_id", res.data.data.add_authorid, "page"]);
					_paq.push(['trackPageView']);
					_paq.push(['enableLinkTracking']);
					(function() {
						var u="https://click-xhncloud.voc.com.cn/";
						_paq.push(['setTrackerUrl', u+'matomo.php']);
						_paq.push(['setSiteId', '140']);
						var d=document, g=d.createElement('script'), s=d.getElementsByTagName('script')[0];
						g.type='text/javascript'; g.async=true; g.src=u+'matomo.js'; s.parentNode.insertBefore(g,s);
					})();
				}else{
				  Dialog.alert({message:res.data.message}).then(()=>{
				    this.toHome();
          })
        }
			});
		} 
	}
</script>
<style>
.newsContent .img{
	width: 100%;
	height: 100%;
	display: block;
	margin: 10Px auto;
	vertical-align: middle;
	margin-bottom: 20Px;
}
</style>
<style scoped>
.detail{
	overflow: hidden;
}
.header{
	width: 100%;
	height: 50Px;
	position: fixed;
	border-bottom: 1Px solid #ccc;
	background: #fff;
	justify-content: center;
	align-items: center;
	top: 0;
	z-index:1;
}
.header .logo{
	margin-left: 5Px;
	line-height: 50Px;
	font-size: 18Px;
}
.de_do{
	display: flex;
    align-items: center;
}
.header button{
	margin-top:5Px;
	width: 80Px;
	height: 40Px;
	float: right;
	margin-right: 20Px;
}
.van-button__text{
	line-height: 40Px;
	font-weight: 500;
	font-size: 18Px;
}
.header img{
	width: 40Px;
	height: 40Px;
	padding:0 .19rem;
}
.content{
	-webkit-overflow-scrolling: touch;
	overflow-y: auto;
	width: 100%;
	height: 100vh;
	padding: 1.22rem 0 0;
	box-sizing: border-box; 
}
 .content>iframe{
	width: 100%;
	height: 100%;
} 
.container{
	margin-top: 40Px
}
.title{
	font-size: 24Px;
	line-height: 30Px;
	text-align: left;
	font-weight: bold;
}
.message{
	font-size: 12Px;
	text-align: center;
	margin:20Px 0px;
	color: #888;
}
.message span:last-child{
	margin-left: 10Px;
}
.newsContent{
	font-size: 18Px;
	line-height: 26Px;
	text-indent: 2em;
	text-align: justify!important;
}
.newsContent>p{
	font-size: 18Px;
	line-height: 26Px;
	text-indent: 2em;
	margin:16Px 0;
}
p{
	text-align: justify!important;
}
</style>
